import React from 'react'
import { FormControl, ControlLabel } from "modules/theme"

const LabelInputWithIcon = (props) => {
  const { label, type = 'text', required = true } = props;
  // console.log("props in label input with icon ", props)
  return (
    <div style={{ marginBottom: "20px" }}>
      <ControlLabel required={required}>{label}</ControlLabel>
      <FormControl
        componentClass='inputIcon'
        required={required}
        type={type}
        {...props}
      />
    </div>
  )
}

export default LabelInputWithIcon


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/LabelInputWithIcon.jsx